//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"AngleTolerance",1,0],[0,"AttributeColor",1,0],[0,"AttributeTitle",1,0],[0,"AttributeValue",1,0],[0,"DistanceTolerance",1,0],[0,"DrawDirection",1,"Direction",0],[1,"Faces",0,"ScCollector",0],[0,"GroupInterval",1,0],[1,"Lower",0,"Expression",0],[0,"ReverseNormalDirection",1,0],[0,"SamplePoints",1,0],[1,"Upper",0,"Expression",0],[0,"UseSurfaceNormal",1,0]],[[["face_id","point","radius","minRadius","maxRadius"],"CalculatePointCurvature",{},2,0],[[],"UpdateRadiusFaces",{},0,0],[["edit","point"],"UpdateLocationLabel",{},2,0],[["attributeColor"],"SetFaceAttributeColor",{},1,0],[[],"UpdateSelectedFacesColor",{},0,0],[["indexArray"],"SetTreeSelectedIndex",{},1,0],[["grpAttributeTitle"],"SetFaceGroupAttributeTitle",{},1,0],[["grpAttributeValue"],"SetFaceGroupAttributeValue",{},1,0]],[]];
SPLM.Features.ConcaveFacesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ConcaveFacesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;